import { isEditorWindow } from './isEditorWindow';
export const getEditorHost = () => {
    var _a;
    if (!isEditorWindow(window)) {
        return null;
    }
    return (_a = window.commonConfig) === null || _a === void 0 ? void 0 : _a.host;
};
